import styles from './style.postcss';

import React from 'react';
import { StudentCard } from 'omni-common-ui';
import PropTypes from 'prop-types';

const MemberCardTd = (props) => <td>
  <div className={styles.MemberCardTd_content}>
    <StudentCard borderless
        className={styles.MemberCardTd_studentCard}>
      <StudentCard.Profile name={props.name}
          localName={props.surname}
          gender={props.gender}
          avatarUrl={props.avatarUrl} />
    </StudentCard>
  </div>
</td>;

MemberCardTd.propTypes = {
  name: PropTypes.string,
  surname: PropTypes.string,
  gender: PropTypes.string,
  avatarUrl: PropTypes.string,
};

export default MemberCardTd;



// WEBPACK FOOTER //
// ./components/TableView/Tds/MemberCardTd/index.jsx